import React, { useState, useEffect } from 'react'
import CommunicationForm from '../../components/species/communication/CommunicationForm'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'

const TemplateManage = (props) => {
    const { t } = useTranslation()
    const data = props.data
    const action = props.action
    const validationArray = Yup.object({
        template: Yup.string().required('Required!'),
    })
    const [initialValues, setInitialValues] = useState({
        id: 0,
        subject: '',
        template: '',
        title: '',
        method: action,
    })
    const resetFrom = () => {
        setInitialValues({
            id: 0,
            subject: '',
            template: '',
            title: '',
            method: action,
        })
        // formik.handleReset()
    }
    const editFunctionHandler = (single_template) => {
        if (single_template.record && data.status === 'edit') {
            const template = single_template.record
            setInitialValues({
                id: data.id,
                subject: template.subject,
                template: template.template,
                title: template.title,
                method: action,
            })
            //setIsLoading(false)
        } else {
            resetFrom()
            // data.status !== 'edit' && setIsLoading(false)
        }
    }

    useEffect(() => {
        setInitialValues({
            ...initialValues,
            method: action,
        })
    }, [action])

    const emailTemplate = []
    if (data.status === 'new') {
        emailTemplate.push({
            label: t('Title'),
            placeholder: t('Enter Title'),
            class: 'col-12',
            type: 'text',
            shrink: true,
            name: 'title',
        })
    }
    emailTemplate.push(
        {
            label: t('Subject'),
            placeholder: t('Enter subject'),
            class: 'col-12',
            type: 'text',
            shrink: true,
            name: 'subject',
        },
        {
            class: 'col-12',
            name: 'template',
            type: global?.communication_templates?.editor || 'ckeditor4',
            version: global?.communication_templates?.version || 'paid',
        }
    )

    const smsTemplate = []
    if (data.status === 'new') {
        smsTemplate.push({
            label: t('Title'),
            placeholder: t('Enter Title'),
            class: 'col-12',
            type: 'text',
            shrink: true,
            name: 'title',
        })
    }
    smsTemplate.push({
        label: t('Template'),
        placeholder: t('Enter Template'),
        class: 'col-12',
        type: 'text',
        name: 'template',
    })

    return (
        <CommunicationForm
            initialValues={initialValues}
            validationArray={validationArray}
            emailTemplate={emailTemplate}
            smsTemplate={smsTemplate}
            data={props.data}
            toggleFullScreenPopup={props.function}
            resetFrom={resetFrom}
            editFunctionHandler={editFunctionHandler}
            hideSubmit={props.hideSubmit}
        />
    )
}

export default TemplateManage
